import axios from 'axios';

import BaseCrud from './baseCrud';

const crud = new BaseCrud('request');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    accept(vuexContext, { id, note, stars }) {
        return axios.$post(`/admin/requests/${id}/accept`, {
            note,
            stars
        });
    },

    reject(vuexContext, { id, note }) {
        return axios.$post(`/admin/requests/${id}/reject`, {
            note
        });
    }
};
